import { Button, Checkbox, Col, Form, Image, Modal, Row, message } from 'antd';
import Title from 'antd/lib/typography/Title';
import { useParams } from "react-router-dom"
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import BookyBox from '../../Components/Layout/BookyBox';
import { TextService } from '../../Services/TextService';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import PagePublicSite from '../../Components/Page/PagePublicSite';
import { WebApiCompanyDtoCompanyPublicSiteDto, WebApiMemberDtoCustomMemberFieldValueDto, WebApiModelsMemberField, WebApiModelsMembershipProduct } from '../../Repository/eventbookyapi';
import NotFound from '../../Components/Page/NotFoundPage';
import { MemberFieldTypes } from '../../Types/MemberFieldTypes';
import { PublicSiteState } from './Types/PublicSiteState';
import { PublicResultType } from './Types/PublicResultType';
import { PublicSiteService } from '../../Services/PublicSiteService';
import { OutPutMemberEditFields } from '../../Components/Forms/OutPutMemberFields';

const PublicSiteNewMember = () => {

    const [publicSite, setPublicSite] = useState([] as WebApiCompanyDtoCompanyPublicSiteDto);
    const [state, setState] = useState(PublicSiteState.Undefined as PublicSiteState);
    const [memberFieldSettings, setMemberFieldSettings] = useState([] as WebApiModelsMemberField[]);
    const [membershipProducts, setMembershipProducts] = useState([] as WebApiModelsMembershipProduct[]);
    const [memberTermsVisible, setMemberTermsVisible] = useState(false);

    let params = useParams();
    const navigation = useNavigate();
    const [form] = Form.useForm();
    const GetText = TextService.GetText;

    useEffect(() => {
        if (params.companyurl != null) {
            try {
                PublicSiteService.GetCompanyPublicSiteByUrl(params.companyurl).then(result => {
                    setPublicSite(result);
                    setState(PublicSiteState.CompanyFound);
                })

                PublicSiteService.GetMemberFieldsByUrl(params.companyurl).then(result => {
                    setMemberFieldSettings(result);
                    setState(PublicSiteState.CompanyFound);
                })

                PublicSiteService.GetMembershipProductsByUrl(params.companyurl).then(result => {
                    setMembershipProducts(result);
                })
            } catch {
                setState(PublicSiteState.CompanyNotFound);
            }
        }
    }, [params, form])

    const getDownloadUrl = (dto: WebApiCompanyDtoCompanyPublicSiteDto) => {
        return process.env.REACT_APP_API_URL + '/Image/downloadImage?bloburl=' + dto.siteLogoPath;
    }

    const MemberCreateClick = async (formValues: any) => {

        try {

            const customFields = [] as WebApiMemberDtoCustomMemberFieldValueDto[];

            memberFieldSettings.forEach((field: WebApiModelsMemberField) => {
                if (field.columnType === MemberFieldTypes.Custom) {
                    customFields.push({
                        fieldId: field.id!,
                        fieldValue: formValues[field.id!]
                    });
                }
            });

            var memberProducts = [];

            // Combine membership and membershipAddon into memberProducts array
            if (formValues.membership) {
                memberProducts.push(formValues.membership);
            }

            if (formValues.membershipAddon && Array.isArray(formValues.membershipAddon)) {
                memberProducts.push(...formValues.membershipAddon);
            }

            await PublicSiteService.AddmemberByMember({
                companyUrl: params.companyurl!,
                firstName: formValues.firstName,
                lastName: formValues.lastName,
                email: formValues.email,
                email2: formValues.email2,
                phoneNumber: formValues.phoneNumber,
                phoneNumber2: formValues.phoneNumber2,
                address: formValues.address,
                postalArea: formValues.postalArea,
                postalCode: formValues.postalCode,
                adressRow2: formValues.adressRow2,
                adressRow3: formValues.adressRow3,
                personalNumber: formValues.personalNumber,
                webPage: formValues.webPage,
                invoiceEmail: formValues.invoiceEmail,
                dateJoined: formValues.joinedDate,
                country: formValues.country,
                company: formValues.company,
                title: formValues.title,
                extra1: formValues.extra1,
                extra2: formValues.extra2,
                extra3: formValues.extra3,
                emailNotificationPreference: formValues.emailNotificationPreference ? 1 : 0,
                customFields: customFields,
                memberProducts: memberProducts
            });
        } catch (error) {
            message.warning(GetText("PublicSiteNewMember_Error"));
            return;
        }

        navigation("/" + getCurrentLanguage() + "/" + params.companyurl + "/success/" + PublicResultType.NewMemberHasBeenRegisted);
    }

    if (state === PublicSiteState.CompanyNotFound) {
        return <NotFound message={GetText("PublicSiteEditMember_CompanyNotFound")} />
    }

    const onPhoneChange = (value: any) => {
        form.setFieldValue("phoneNumber", value);
    }

    return <PagePublicSite>
        <BookyBox>

            {publicSite.siteLogoPath ? <div style={{ marginBottom: "20px" }}>
                <Image preview={false} className='company-logo' src={getDownloadUrl(publicSite)} ></Image>
            </div>
                : <Title style={{ margin: 0 }}>{publicSite.siteTitle}</Title>}

            <h2>{GetText("PublicSiteNewMember_NewMemberTitle")}</h2>
            {publicSite.siteDescription && publicSite.siteDescription.length > 0 ? <p dangerouslySetInnerHTML={{ __html: publicSite.siteDescription! }}></p> : ""}

            <Form
                data-testid="create-form"
                name="basic"
                form={form}
                colon={false}
                onFinish={MemberCreateClick}
                layout="vertical"
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <OutPutMemberEditFields
                    memberFieldSettings={memberFieldSettings}
                    membershipProducts={membershipProducts}
                    GetText={GetText}
                    groups={[]} // Pass groups if needed, or [] if not used
                    user={{ hasOnlyReadRights: false }} // Pass user object if needed, or a minimal object
                    onPhoneChange={onPhoneChange}
                    isAdmin={false}
                />

                {publicSite.memberTerms && publicSite.memberTerms.length > 0 && (
                    <Form.Item
                        name="memberTermsAccepted"
                        valuePropName="checked"
                        rules={[
                            {
                                validator: (_, value) =>
                                    value ? Promise.resolve() : Promise.reject(new Error(GetText("PublicSiteNewMember_MemberTermsRequired"))),
                            },
                        ]}
                    >
                        <Checkbox>
                            {GetText("PublicSiteNewMember_AcceptMemberTerms")}{" "}
                            <a onClick={(e) => { e.preventDefault(); setMemberTermsVisible(true); }}>
                                {GetText("PublicSiteNewMember_MemberTermsLink")}
                            </a>
                        </Checkbox>
                    </Form.Item>
                )}

                <Modal
                    title={GetText("PublicSiteNewMember_MemberTermsTitle")}
                    open={memberTermsVisible}
                    onCancel={() => setMemberTermsVisible(false)}
                    footer={[
                        <Button key="close" onClick={() => setMemberTermsVisible(false)}>
                            {GetText("Common_Close")}
                        </Button>
                    ]}
                    width={700}
                >
                    <div dangerouslySetInnerHTML={{ __html: publicSite.memberTerms || "" }} />
                </Modal>

                <Form.Item
                    label=""
                    name="submit"
                    rules={[
                        {
                            required: false,
                            message: 'submitbutton',
                        },
                    ]}
                >
                    <Button data-testid="submit-button" className='saveButton' size="middle" type="primary" htmlType="submit">
                        {GetText("EditMember_ModalOk")}
                    </Button>
                </Form.Item>
            </Form>
        </BookyBox>
    </PagePublicSite>
}

export default PublicSiteNewMember;